import yup from '@/libs/yup';

export default yup.object().shape({
    idn: yup.string().required(),
    version: yup.string().required(),
    project_version_id: yup.string().required(),
    is_public: yup.boolean().required()
});
